import { useContext } from 'react'
import { BusinessIdContext } from 'routes/components/AppPage/components/BusinessIdProvider/BusinessIdProvider'

export const useBusinessIdPathParam = () => useContext(BusinessIdContext).businessId || ''
